const FinBankCreditScoreInfoI18n = {
  scoreInfo: {
    sections: {
      personalData: 'Datos de registro persona física',
      companyData: 'Datos de registro persona jurídica',
      contact: 'Contacto',
      address: 'Dirección',
    },
    personalData: {
      cpf: 'CPF',
      nome: 'Nombre',
      nomeMae: 'Nombre de la madre',
      dataNascimento: 'Fecha de nacimiento',
      nacionalidade: 'Nacionalidad',
      obito: 'Fallecido',
      escolaridade: 'Escolaridad',
    },
    companyData: {
      cnpj: 'CNPJ',
      razaoSocial: 'Razón social',
      nomeFantasia: 'Nombre de fantasía',
      natureza: 'Naturaleza',
      situacaoCnpj: 'Situación CNPJ',
      atividadePrincipal: 'Actividad principal',
      dataAbertura: 'Fecha de apertura',
      capitalSocial: 'Capital social actual',
      dataCapitalSocial: 'Fecha de la última modificación del capital',
    },
    contact: {
      telefonePrincipal: 'Teléfono principal',
      telefoneSecundario: 'Teléfono secundario',
    },
    address: {
      itemLabel: 'Dirección {{index}}',
      pageIndicator: '{{current}} de {{total}}',
      rua: 'Calle',
      bairro: 'Barrio',
      cidade: 'Ciudad',
      complemento: 'Complemento',
      estado: 'Estado',
      cep: 'Código postal',
      empty: 'Ninguna dirección registrada',
    },
    consumerStatus: {
      title: 'Estado del consumidor',
      subtitleActive: 'Registro positivo',
      subtitleInactive: 'Registro negativo',
      active: 'Activo',
      inactive: 'Inactivo',
    },
    values: {
      yes: 'Sí',
      no: 'No',
      notInformed: 'No informado',
    },
  },
};

export default FinBankCreditScoreInfoI18n;
